import { vaultGetRequest } from '../helpers';
import type { IVaultHealthResponse } from './fetch-health-response';
import { vaultHealthResponseSchema } from './fetch-health-response';

export async function fetchHealthApi(): Promise<IVaultHealthResponse> {
  return vaultGetRequest({ path: '/health', schema: vaultHealthResponseSchema });
}
